import { Button, Image } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { LINKS } from '@/constants'
import { useMobileDetection } from '@/hooks/useMobileDetection'
import desktopImage from '@/static/img/getapp_desktop.min.svg'
import mobileImage from '@/static/img/getapp_mobile.min.svg'

export function MobileAppWidget() {
    const { t } = useTranslation()
    const { isIOS } = useMobileDetection()

    const getTheAppLink = isIOS ? LINKS.APP.IOS : LINKS.APP.ANDROID
    const howToLink = isIOS ? LINKS.APP.HOW_TO.IOS : LINKS.APP.HOW_TO.ANDROID

    return (
        <>
            {/* Desktop */}
            <Flex display={['none', 'none', 'flex']} flexDir="row" flexGrow="1" justifyContent="center">
                <Box display="flex" justifyContent="center" alignItems="center" width="100%" maxW="780px">
                    <Box width="50%" display="flex" justifyContent="space-around">
                        <Image src={desktopImage} />
                    </Box>
                    <Box width="50%" display="flex" flexDir="row" justifyContent="center">
                        <Box maxW="390px" textAlign="center">
                            <Text fontSize="32px" fontWeight="bold" lineHeight="40px" mb="16px">
                                {t('global.appPage.mobile.title')}
                            </Text>
                            <Text fontSize="16px" lineHeight="24px">
                                {t('global.appPage.mobile.subtitle_1')}
                                <br />
                                {t('global.appPage.mobile.subtitle_2')}
                            </Text>
                            <Button asChild mt="38px" width="100%" variant="secondary">
                                <a href={howToLink} target="_blank">
                                    {t('global.appPage.mobile.button_1')}
                                </a>
                            </Button>
                            <Button asChild mt="8px" width="100%" variant="primary">
                                <a href={getTheAppLink} target="_blank">
                                    {t('global.appPage.mobile.button_2')}
                                </a>
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Flex>

            {/* Mobile */}
            <Flex display={['flex', 'flex', 'none']} alignItems="center" flexGrow="1" flexDir="row" width="100%" height="100%">
                <Box width="100%" height="100%" display="flex" flexDir="column" flexGrow="1" justifyContent="center" alignItems="center">
                    <Box width="100%" maxW="390px">
                        <Image src={mobileImage} width="100%" />
                    </Box>
                    <Box width="100%" maxW="390px" mt="38px" textAlign="center">
                        <Text fontSize="32px" fontWeight="bold" lineHeight="40px" mb="8px">
                            {t('global.appPage.mobile.title')}
                        </Text>
                        <Text fontSize="16px" lineHeight="24px">
                            {t('global.appPage.mobile.subtitle_1')}
                            <br />
                            {t('global.appPage.mobile.subtitle_2')}
                        </Text>
                        <Button asChild mt="38px" width="100%" variant="secondary">
                            <a href={howToLink} target="_blank">
                                {t('global.appPage.mobile.button_1')}
                            </a>
                        </Button>
                        <Button asChild mt="8px" width="100%" variant="primary">
                            <a href={getTheAppLink} target="_blank">
                                {t('global.appPage.mobile.button_2')}
                            </a>
                        </Button>
                    </Box>
                </Box>
            </Flex>
        </>
    )
}
